import { ActiveMemory } from "@/memory/types";

export const memoryOperations = {
  get(): ActiveMemory {
    const storedMemory = sessionStorage.getItem("heliumMemory");
    return storedMemory ? JSON.parse(storedMemory) : {};
  },

  set(value: ActiveMemory) {
    const currentMemory = this.get();
    const updatedMemory = { ...currentMemory, ...value };
    sessionStorage.setItem("heliumMemory", JSON.stringify(updatedMemory));
  },

  clear() {
    sessionStorage.removeItem("heliumMemory");
  },

  getTotalWithHistory() {
    const currentDate = new Date().toISOString().split("T")[0];

    const updatedMemories = {
      [currentDate]: [this.get()],
    };

    return updatedMemories;
  },

  persistToLocalStorage() {
    this.set(this.get());
  },

  clearStoredMemories() {
    localStorage.removeItem("helium_memory");
  },
};
